<template>
    <app-dashboard-tiles :title="title" :legend-title="legendTitle" chart-classes="w-full">
        <template v-slot:chart>
            <horizontal-bar-chart :data="data" :options="options" :style="height ? { height } : ''" />
        </template>
        <template v-slot:legendFooter>
            <slot name="legendFooter"></slot>
        </template>
        <template v-slot:icon>
            <slot name="icon"></slot>
        </template>
    </app-dashboard-tiles>
</template>
<script>
import AppDashboardTiles from '@/components/app-dashboard-tiles/AppDashboardTiles.vue';
import { Bar } from 'vue-chartjs';

const HorizontalBarChart = {
    extends: Bar,
    props: ['chartData', 'options'],
};
export default {
    components: { AppDashboardTiles, HorizontalBarChart },
    props: {
        title: { type: String, default: () => '' },
        legendTitle: { type: String, default: () => '' },
        data: { type: Object, default: () => [] },
        height: { type: String },
        options: {
            type: Object,
            default: () => ({
                layout: {
                    padding: 40,
                },
                indexAxis: 'y',
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    y: {
                        ticks: {
                            display: true,
                            autoSkip: false,
                        },
                    },
                },
                plugins: {
                    datalabels: {
                        anchor: 'end',
                        align: 'end',
                        formatter: function (value, context) {
                            return value > 0 && value < 100 ? value + '%' : ''; // Display the actual data value
                        },
                    },
                },
            }),
        },
    },
};
</script>
